import { useTranslation } from 'react-i18n-lite'

import { Icon } from '@yes.technology/react-toolkit'

import useWindowSize from '../WebcamCapture/hooks/useWindowSize'
import Player from '../WebcamStreamCapture/components/Player'

type VideoViewProps = {
  video: string
  videoType?: string
  onCancel: () => void
}

const VideoView = ({ video, videoType, onCancel }: VideoViewProps) => {
  const { t } = useTranslation()

  const size = useWindowSize()

  return (
    <div
      className='webcam'
      style={{
        width: size.width,
        height: size.height,
        background: '#000000',
        position: 'fixed',
        top: '0',
        right: '0',
        bottom: '0',
        left: '0',
        zIndex: 2
      }}
    >
      <div className='position-relative'>
        <div className='webcam-header-view'>
          <div className='webcam-header-elements'>
            <button type='button' className='icon-button' onClick={onCancel}>
              <Icon iconName='Close' icSize='small' />
            </button>
            <span>{t('activity-document-photo.webcam.view')}</span>
          </div>
        </div>
        <div
          className='d-flex justify-content-center align-items-center'
          style={{
            height: `calc(100vh - 50px)`,
            width: '100%',
            padding: '20px',
            boxSizing: 'border-box'
          }}
        >
          <div style={{ width: '100%', height: '100%', position: 'relative' }}>
            <Player
              source={video}
              type={videoType || 'video/mp4'}
              style={{
                objectFit: 'contain',
                width: '100%',
                height: '100%',
                display: 'block'
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default VideoView
